import { render, staticRenderFns } from "./Justdial.vue?vue&type=template&id=77f4aed4&scoped=true"
import script from "./Justdial.vue?vue&type=script&lang=js"
export * from "./Justdial.vue?vue&type=script&lang=js"
import style0 from "./Justdial.vue?vue&type=style&index=0&id=77f4aed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4aed4",
  null
  
)

export default component.exports